import { createFileRoute } from '@tanstack/react-router'
import { FemaLandingPage } from '../components/FemaLandingPage'
import { femaHead, loadFemaLanding } from '../lib/femaPage'

export const Route = createFileRoute('/cd-fema')({
  loader: loadFemaLanding,
  head: ({ loaderData }) => femaHead(loaderData),
  component: Page,
})

function Page() {
  return <FemaLandingPage {...Route.useLoaderData()} />
}
